module.exports = __webpack_public_path__ + "static/media/img4.d216a9a0.jpg";